import { get, post } from '../utils/request';

// 定义接口返回的数据类型

interface IBoaPay {
  amount: number;
  bill_to_address_city: string;
  bill_to_address_country: string;
  bill_to_address_line1: string;
  bill_to_address_line2: string;
  bill_to_address_postal_code: string;
  bill_to_address_state: string;
  bill_to_company_name: string;
  bill_to_email: string;
  bill_to_forename: string;
  bill_to_phone: string;
  bill_to_surname: string;
  order_id: string;
}

interface IStripePay {
  addr: string;
  email: string;
  name: string;
  order_id: string;
  payment_type: string;
  phone: string;
  signal: any;
  user_id: string;
}


interface UserInfo {
  id: number;
  username: string;
  email: string;
  avatar?: string;
  roles: string[];
}



// 生成商品订单
export const generateOrder = (data: any) => {
  return post<any>('/order/save_product_order', data);
};
// 生成紧急服务商品订单 预付款
export const createPrepaymentOrder = (data: any) => {
  return post<any>('/emergency_service/create_prepayment_order', data);
};
// 生成紧急服务商品订单 尾款
export const createFinalPaymentOrder = (data: any) => {
  return post<any>('/emergency_service/create_final_payment_order', data);
};
// 到达---工程师确认
export const reportArrival = (data: any) => {
  return post<any>('emergency_service/report_arrival', data);
};
// 到达---用户确认
export const confirmArrival = (data: any) => {
  return post<any>('emergency_service/confirm_arrival', data);
};
// 服务完成---工程师确认
export const reportCompletion = (data: any) => {
  return post<any>('emergency_service/report_completion', data);
};
// 服务完成---用户确认
export const confirmCompletion = (data: any) => {
  return post<any>('emergency_service/confirm_completion', data);
};
// 生成普通服务订单
export const generateServiceOrder = (data: any) => {
  return post<any>('/order/save_service_order', data);
};


// 美国stripe支付
export const stripePay = (data: IStripePay) => {
  return post<any>('/payment/save_to_start_stripe_pay', data);
};


// 美国boa银行卡支付
export const boaPay = (data: IBoaPay) => {
  return post<any>('/payment/save_to_start_boa_pay', data);
};


// 获取订单商品列表
export const getOrderProductDataByProductIdList = (data: any) => {
  return post<any>('/product/get_product_data_by_product_id_list', data);
};


// 获取用户地址列表
export const getUserAddressList = () => {
  return get<any>('/user/get_user_address_list');
};


// 保存订单地址
export const saveOrderAddress = (data: any) => {
  return post<any>('/user/save_user_address', data);
};

// 删除订单地址
export const deleteOrderAddress = (data: any) => {
  return post<any>('/user/delete_user_address', data);
};

// 获取用户信息
export const getUserInfo = () => {
  return get<UserInfo>('/user/info');
};

// 获取商品订单页列表
export const getOrderPageList = (data:any) => {
  return get<any>('/order/get_product_order_page_list', data);
};

// 获取所有订单列表
export const getOrderAllList = (data: any) => {
  return get<any>('/order/get_product_order_all_list', data);
};

// 根据id获取订单
export const getOrderById = (order_id: string) => {
  return get<any>(`/order/get_product_order_by_product_order_id?product_order_id=${order_id}`);
};
// order/get_order_item_by_order_id?order_id=ORD-00000001
export const getOrderItemByOrderID = (order_id: string) => {
  return get<any>(`/order/get_order_item_by_order_id?order_id=${order_id}`);
};

// 模糊查询订单接口  keyword: 订单号
export const getOrderByKeyword = (keyword: string) => {
  return get<any>(`/order/get_product_order_by_keyword?keyword=${keyword}`);
};



// 修改shipping address 地址
export const editSaveOrderAddress = (data: any) => {
  return post<any>('/order/save_order_address', data);
};

// 修改billing address 地址
export const editSaveOrderBillingAddress = (data: any) => {
  return post<any>('/order/save_order_billing_address', data);
};

// 订单状态
export const saveOrderStatus = (data: any) => {
  return post<any>('/order/save_order_status', data);
};
// 紧急服务订单列表  keyword: 订单号
export const getEmergencyServiceList = (query:any) => {
  return get<any>(`/emergency_service/get_emergency_service_list`,query);
};

// 紧急服务订单进度详情接口
export const getEmergencyServiceById = (data: any) => {
  return get<any>(`/emergency_service/get_emergency_service_by_id`,data);
};

// 删除商品订单接口
export const saveOrderDelete = (data: any) => {
  return post<any>('/order/save_product_order_delete', data);
};

// 商品取消订单
export const saveOrderCancel = (data: any) => {
  return post<any>('/order/save_product_order_cancel', data);
};

// 商品订单完成（到店消费点击完成，平台打款给商家）
export const saveOrderComplete = (data: any) => {
  return post<any>('/order/save_product_order_complete', data);
};

// 商品订单退款（购买的商品不想要了，需要退款）
export const saveOrderRefund = (data: any) => {
  return post<any>('/order/save_product_order_refund', data);
};


// 订单状态
export const saveProductOrderStatus = (data: any) => {
  return post<any>('/order/save_product_order_status', data);
};


// 从已发货订单中抽取5个产品展示
export const getProductFromOrder = () => {
  return get<any>(`/order/get_product_from_order`);
};



// 获取推荐产品列表
export const getSuggestProductList = (data: any) => {
  return get<any>(`/order/get_suggest_product_list`,data);
};


// 获取推荐产品列表
export const getSuggestWebProductList = (data: any) => {
  return get<any>(`/web/get_suggest_product_list`,data);
};

// 获取订单统计数据
export const getOrderCount = () => {
  return get<any>(`/order/get_product_order_count`);
};


// 申请售后
export const saveApplyAfterSale = (data: any) => {
  return post<any>(`/order/save_apply_after_sale`,data);
};



// 获取订单支付成功的状态
export const getOrderPaymentSuccessStatus = (order_id: string) => {
  return get<any>(`/order/get_check_order_payment_status?order_id=${order_id}`);
};




//获取商家订单
export const getStoreOrderList = (data: any) => {
  return get<any>(`/merchant/get_product_order_item_all_list_by_merchant_id`,data);
}




// 获取服务详情
export const getServiceOrderListByIds = (data: any) => {
  return post<any>('/web/get_service_list_by_ids', data);
};



// 用户获取商品订单页列表
export const getUserServiceProductOrderPageList = (data:any) => {
  return get<any>('/order/get_service_order_page_list', data);
}



// 用户普通服务订单取消
export const saveServiceOrderCancel = (data: any) => {
  return post<any>('/order/save_service_order_cancel', data);
};


// 用户普通服务订单删除
export const saveServiceOrderDelete = (data: any) => {
  return post<any>('/order/save_service_order_delete', data);
};


// 用户普通服务订单完成（到店消费点击完成，平台打款给商家）
export const saveServiceOrderComplete = (data: any) => {
  return post<any>('/order/save_service_order_complete', data);
};
// 获取二维码
export const getQrcode = (data: any) => {
  return post<any>('/order/create_order_qrcode', data);
};
// 商家取件码确认用户已确认收货
export const confirmReceipt = (data: any) => {
  const { order_id, pickup_code, merchant_id} = data
  return get<any>(`/order/confirm_receipt?order_id=${order_id}&pickup_code=${pickup_code}&merchant_id=${merchant_id}`);
};


